// Teléfono del registro: el código de país sale del selector y el número se escribe
// como cada uno lo tenga anotado ("0351 15 789-1695", "+54 9 351 7891695"...). Se guarda
// siempre igual, en formato internacional, que es el que sirve para WhatsApp.
// La misma regla está en functions/src/usuarios/telefono.js: si cambia una, cambiar la otra.

/** Cómo escribir un número de Argentina, para el aviso del formulario. */
export const AYUDA_ARGENTINA = 'Código de área sin el 0 y número sin el 15. Ej.: 351 789 1695.';

/**
 * Los 10 números de un teléfono de Argentina (código de área y número), o '' si no
 * se puede armar: "0351 15 789-1695" → "3517891695", "+5493517891695" → "3517891695".
 */
function argentina(escrito) {
    let d = String(escrito || '').replace(/\D/g, '');
    // Pegado con el código de país, aunque el selector ya lo ponga ("+54 9 351…"):
    // ningún código de área empieza con 5 ni con 9.
    while (d.startsWith('54') && d.length > 10) d = d.slice(2);
    if (d.startsWith('9') && d.length > 10) d = d.slice(1);
    if (d.startsWith('0')) d = d.slice(1);
    // El 15 de los celulares va después del código de área, que tiene 2, 3 o 4 números.
    if (d.length === 12) {
        const area = [2, 3, 4].find((n) => d.slice(n, n + 2) === '15');
        if (area) d = d.slice(0, area) + d.slice(area + 2);
    }
    return /^[123]\d{9}$/.test(d) ? d : '';
}

/**
 * El teléfono en formato internacional ("+5493517891695"), o '' si el número no está
 * completo. `codigoPais` es el del selector ("+54", "+598"...).
 */
export function normalizarTelefono(codigoPais, escrito) {
    if (codigoPais === '+54') {
        const d = argentina(escrito);
        return d ? `+549${d}` : '';
    }
    const pais = String(codigoPais || '').replace(/\D/g, '');
    let d = String(escrito || '').replace(/\D/g, '');
    if (pais && d.startsWith(pais) && d.length > pais.length + 7) d = d.slice(pais.length);
    d = d.replace(/^0+/, '');
    return pais && /^\d{8,11}$/.test(d) ? `+${pais}${d}` : '';
}

/** "+5493517891695" → "+54 9 351 789-1695" (con área de 3) para mostrarlo. */
export function telefonoLegible(telefono) {
    const m = String(telefono || '').match(/^\+549(\d{10})$/);
    if (!m) return telefono;
    const d = m[1];
    // Área de 2 en Buenos Aires (11), de 3 o 4 en el resto: sin la guía no se sabe
    // dónde termina, así que se agrupa como la mayoría (3).
    const area = d.startsWith('11') ? 2 : 3;
    const resto = d.slice(area);
    return `+54 9 ${d.slice(0, area)} ${resto.slice(0, resto.length - 4)}-${resto.slice(-4)}`;
}

/** "+5493517891695" → el link que abre un chat de WhatsApp con ese número. */
export function linkDeWhatsApp(telefono) {
    return `https://wa.me/${String(telefono).replace(/\D/g, '')}`;
}
